export const pxr = (px: number) => `${px / 16}rem`